if (typeof StickyAddToCart !== 'function') {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super()
      this.product = document.querySelector('product-page')
      if (this.product) {
        this.init()
      }
    }

    init() {
      window.addEventListener('scroll', this.handleScroll.bind(this))
      window.addEventListener('resize', this.handleScroll.bind(this))
      this.handleScroll()
    }

    handleScroll() {
      const productRect = this.product.getBoundingClientRect()
      const windowHeight = window.innerHeight

      if (productRect.bottom < 0 || productRect.top > windowHeight) {
        this.classList.add('is-visible')
      } else {
        this.classList.remove('is-visible')
        const openDetails = this.querySelector('details[open]')
        if (openDetails) {
          openDetails.removeAttribute('open')
        }
      }

      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        this.classList.remove('is-visible')
        const openDetails = this.querySelector('details[open]')
        if (openDetails) {
          openDetails.removeAttribute('open')
        }
      }
    }
  }

  if (typeof customElements.get('sticky-add-to-cart') === 'undefined') {
    customElements.define('sticky-add-to-cart', StickyAddToCart)
  }
}
